'use client';

import React from 'react';
import { useRouter } from 'next/navigation';
import Icon from '@/components/ui/AppIcon';
import { Button } from '@/components/ui';

export default function NotFound() {
  const router = useRouter();

  const handleGoHome = () => {
    router?.push('/');
  };

  const handleGoBack = () => {
    if (typeof window !== 'undefined') {
      window.history?.back();
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-brand-bg p-4">
      <div className="text-center max-w-md">
        <div className="flex justify-center mb-6">
          <div className="relative">
            <h1 className="text-9xl font-bold text-brand-primary opacity-20">404</h1>
          </div>
        </div>

        <h2 className="text-2xl font-medium text-brand-text-dark mb-2">Page Not Found</h2>
        <p className="text-brand-text/70 mb-8">
          The page you're looking for doesn't exist. Let's get you back!
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button onClick={handleGoBack} variant="primary">
            <Icon name="ArrowLeftIcon" size={16} />
            Go Back
          </Button>

          <Button onClick={handleGoHome} variant="outline">
            <Icon name="HomeIcon" size={16} />
            Back to Home
          </Button>
        </div>
      </div>
    </div>
  );
}
